import actionTypes from './action-types';

export const setAction = (data) => ({
  type: actionTypes.app.set,
  data,
});
